import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

import AsyncSelect from "react-select3/async";
import { customToast as toast } from "../../utils";
import ProjectService from "../../services/projectService";

const ProjectSelect = ({
  onChange,
  isLoading,
  selectedCustomers,
  setGlobalLoading,
  value: initialValue,
  loadProjects,
  defaultData,
  label,
  placeholder,
  filterResult = (p) => p,
  disabled
}) => {
  const [selectLoading, setLoading] = useState(false);

  const [defaultOptions, setDefaultOptions] = useState(defaultData);

  useEffect(() => {
    const loadDefaultOptions = async () => {
      try {
        let projects = [];

        if (selectedCustomers && selectedCustomers.length > 0) {
          projects = await ProjectService.findByNameAndCustomers(
            "",
            selectedCustomers.map((sC) => (sC?.value ? sC.value : sC))
          );
        } else {
          projects = await ProjectService.findByNameAndCustomers(null, null);
        }

        setDefaultOptions(
          projects.filter(filterResult).map(({ _id, name }) => ({
            value: _id,
            label: name
          }))
        );

        if (loadProjects) {
          loadProjects(projects);
        }

        if (setGlobalLoading) {
          setGlobalLoading(false);
        }
      } catch (error) {
        toast.error();
      } finally {
        if (setGlobalLoading) {
          setGlobalLoading(false);
        }
        setLoading(false);
      }
    };
    if (selectedCustomers?.length > 0 || !selectedCustomers?.length) {
      if (setGlobalLoading) {
        setGlobalLoading(true);
      }
      setLoading(true);
      loadDefaultOptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCustomers]);

  const loadingOptions = useCallback(
    async (inputValue = "") =>
      new Promise((resolve) => {
        setLoading(true);
        if (setGlobalLoading) {
          setGlobalLoading(true);
        }
        if (
          defaultOptions &&
          Array.isArray(defaultOptions) &&
          defaultOptions.length > 0 &&
          !selectLoading
        ) {
          const arrayFiltered = defaultOptions.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
          );
          setDefaultOptions(arrayFiltered);
          resolve(arrayFiltered);
        }
        if (setGlobalLoading) {
          setGlobalLoading(false);
        }
        setLoading(false);
      }),
    [setGlobalLoading, defaultOptions, selectLoading]
  );

  const value = Array.isArray(initialValue)
    ? defaultOptions.filter((x) =>
        initialValue.find((i) => i.value === x.value || i === x.value)
      )
    : initialValue;

  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="project-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <AsyncSelect
        isClearable
        defaultOptions={defaultOptions}
        id="project-select"
        name="project-select"
        placeholder={placeholder}
        className="react-select-container"
        classNamePrefix="react-select-container"
        cacheOptions
        isLoading={selectLoading || isLoading}
        loadOptions={loadingOptions}
        onChange={onChange}
        isMulti
        value={value}
        noOptionsMessage={({ inputValue }) =>
          inputValue.length ? "No options" : "Start typing..."
        }
        isDisabled={disabled}
      />
    </React.Fragment>
  );
};

ProjectSelect.propTypes = {
  onChange: PropTypes.func,
  selectedCustomers: PropTypes.array,
  isLoading: PropTypes.bool,
  value: PropTypes.any,
  loadProjects: PropTypes.func,
  defaultData: PropTypes.array,
  setGlobalLoading: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  filterResult: PropTypes.func,
  disabled: PropTypes.bool
};

ProjectSelect.defaultProps = {
  isLoading: false,
  loadProjects: false,
  defaultData: [],
  selectedCustomers: null,
  setGlobalLoading: () => {},
  placeholder: "Project",
  disabled: false
};
export default ProjectSelect;
